








import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class FormResultError extends Vue {
  @Prop() private messages!: string[]
}
